import { useState } from 'react'

import { type Quote } from '../../../modules/quotes'
import { QuoteComponentContextProvider } from '../QuoteComponent.context'
import { type QuoteComponentOptions } from '../QuoteComponent.types'
import Jobs from '../Jobs'
import Footer from '../Footer'
import { mergeClassName } from '../../../utils/mergeClassName'

type AvailableOptions = Pick<QuoteComponentOptions, 'ignoreConstraints' | 'promoCode' | 'jobId' | 'docTop' | 'darkBackground'>

type QuoteDetailsProps = {
  quote: Quote
  options?: AvailableOptions
}

const QuoteDetails: React.FC<QuoteDetailsProps> = ({
  quote,
  options,
}) => {
  const [selectedJob, setSelectedJob] = useState(0)
  const usCompany = quote.companyBranch.country.toUpperCase() === 'US'
  const useMiles = usCompany

  const multiJobs = quote.jobs.length > 1

  return (
    <QuoteComponentContextProvider
      open
      highlighted={false}
      selectedJob={selectedJob}
      setSelectedJob={setSelectedJob}
      multiJobs={quote.jobs.length > 1 && !options?.jobId}
      nbJobs={quote.jobs.length}
      useMiles={useMiles}
      showAlternativeDates={false}
      showSummary={false}
      showPlusTaxes
      emphasisEstimate
      {...options}
    >
      <Jobs
        quote={quote}
        className={mergeClassName(
          !multiJobs && 'border-t-0 md:px-3',
        )}
      />
      <Footer
        quote={quote}
        className="mb-0 items-start gap-y-0 border-t-0 pb-0 pl-3"
      />
    </QuoteComponentContextProvider>
  )
}

export default QuoteDetails
